import { Button, makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import TinyMCE from '../../atoms/TinyMCE';
import { useNotification } from '../../contexts/Notification';
import Strapi from '../../services/strapi';

const useStyles = makeStyles((theme) => ({
	button: {
		marginBottom: '1vh'
	}
}));

interface PageEditorProps {
	collection: string,
	name: string
}

const PageEditor = (props: PageEditorProps) => {
	const [content, setContent] = useState<string>("");
	const notification = useNotification();
	const classes = useStyles()

	useEffect(() => {
		Strapi.get(props.collection).then((r) => {
			setContent(r.content);
		});
	}, [props.collection]);

	const update = () => {
		notification.notify("updating page...", "info");
		Strapi.put(props.collection, {}, {
			content,
		}).then(r => {
			notification.notify("page updated");
		}).catch(e => {
			notification.notify("fail to update page", "error");
		})
	};

	return (
		<div>
			<Button
				variant="contained"
				color="primary"
				onClick={update}
				className={classes.button}
			>Sauvegarder<br/>"{props.name}"</Button>
			<TinyMCE
				value={content}
				onEditorChange={(c, e) => {
					setContent(c);
				}}
			/>
		</div>
	);
}

export default PageEditor;

